import * as React from 'react'
import List from '@mui/material/List'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material'
import { ExpandMore } from '@mui/icons-material'

export interface ListElement {
  name: string
  subItems?: ListElement[]
  type?: string
  isHidden?: boolean
  id?: string
  unit?: string
  value?: string
}

interface StructuralSettingListProps {
  items: ListElement[]
}

const StructuralSettingList: React.FC<StructuralSettingListProps> = ({
  items,
}) => {
  return (
    <List sx={{ width: '100%' }} component='nav'>
      {items.map((item) => (
        <Accordion
          key={item.name}
          slotProps={{ heading: { component: 'h6' } }}
          defaultExpanded
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls='panel1-content'
            id='panel1-header'
          >
            <Typography
              sx={{
                fontSize: '12px',
                fontWeight: 500,
              }}
            >
              {item.name}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ p: 1 }}>
            {item.subItems?.map((subItem) => (
              <Box
                key={subItem.name}
                sx={{ display: 'flex', gap: 1, mb: '5px', color: '#737373' }}
              >
                <Typography
                  sx={{
                    alignContent: 'center',
                    width: '60%',
                    fontSize: '12px',
                    fontWeight: 500,
                    textAlign: 'left',
                  }}
                >
                  {subItem.name}
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    backgroundColor: '#F5F5F5',
                    radius: '4px',
                    gap: 1,
                    width: '50%',
                    padding: '3px',
                  }}
                >
                  <Box sx={{ display: 'flex', gap: '4px', width: '70%' }}>
                    <Typography
                      sx={{
                        fontSize: '14px',
                        fontWeight: 400,
                      }}
                    >
                      {subItem.value}
                    </Typography>
                    <Typography
                      sx={{
                        alignContent: 'center',
                        fontSize: '8px',
                        fontWeight: 400,
                      }}
                    >
                      {subItem.unit}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: '7px',
                        padding: '3px',
                        borderRadius: '4px',
                        fontWeight: 400,
                        backgroundColor: '#97999B',
                        color: '#FBFBFB',
                      }}
                    >
                      {subItem.type}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </AccordionDetails>
        </Accordion>
      ))}
    </List>
  )
}

export default StructuralSettingList
